var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSteamLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    fill: "url(#paint0_linear_2780_37653)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5713 59.9941C38.9237 59.9941 39.2762 59.9941 39.6678 60.0332L52.7867 40.7269C52.7867 29.057 62.2636 19.5801 73.9335 19.5801C85.6035 19.5801 95.0804 29.057 95.0804 40.7269C95.0804 52.3969 85.6035 61.8738 73.9335 61.8738C73.7769 61.8738 73.6202 61.8738 73.4636 61.8738L54.7055 75.2276C54.7055 75.5409 54.7447 75.815 54.7447 76.1283C54.7447 85.057 47.5 92.3018 38.5713 92.3018C30.6216 92.3018 24.0426 86.5843 22.672 79.0262L1.88472 70.4369C0.138387 63.8924 -0.345619 57.5973 0.241453 50.5832L29.2902 62.892C31.9139 61.0514 35.1251 59.9941 38.5713 59.9941ZM74.0118 29.9969C79.9251 29.9969 84.7028 34.7745 84.7028 40.6878C84.7028 46.6011 79.9251 51.3787 74.0118 51.3787C68.0986 51.3787 63.3209 46.6011 63.3209 40.6878C63.3209 34.7745 68.1377 29.9969 74.0118 29.9969ZM74.0118 26.6682C81.7265 26.6682 88.0314 32.9339 88.0314 40.6878C88.0314 48.4416 81.7657 54.7074 74.0118 54.7074C66.258 54.7074 59.9923 48.4416 59.9923 40.6878C59.9923 32.9339 66.2972 26.6682 74.0118 26.6682ZM38.5713 64.2234C45.1503 64.2234 50.4762 69.5493 50.4762 76.1283C50.4762 82.7074 45.1503 88.0332 38.5713 88.0332C33.7937 88.0332 29.6426 85.2136 27.7629 81.1409C30.5042 82.2766 35.3993 84.7829 38.1797 84.7829C43.0356 84.7829 46.9909 80.8276 46.9909 75.9717C46.9909 68.5311 39.7461 67.3563 34.3028 65.0458C35.6342 64.4976 37.0832 64.2234 38.5713 64.2234Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2780_37653",
    x1: 56,
    y1: 0,
    x2: 56,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F1B31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#11265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1883B6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteamLink);
export default __webpack_public_path__ + "static/media/steam-link.8e3464fa79b575a12ce55f53531b5692.svg";
export { ForwardRef as ReactComponent };